import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import { updateUserInfo } from 'actions'
import {
  consultantNameSelector,
  consultantEmployerSelector,
  consultantTitlesSelector,
  consultantAvailabilityValueSelector,
  consultantProfilePictureSelector,
  updateUserInfoPendingSelector,
  consultantMobileSelector,
  consultantDateOfBirthSelector,
} from 'selectors'

import {
  Form,
  Field,
  Label,
  Input,
  RolesInput,
  AvailabilityInput,
  ProfilePictureInput,
} from 'components/form'
import Button from 'components/Button'

class EditUserInfo extends React.Component {
  state = {
    name: this.props.name,
    employer: this.props.employer,
    titles: this.props.titles,
    availability: {
      ...this.props.availability,
      date: this.props.availability.date
        ? moment(this.props.availability.date)
        : undefined,
    },
    profilePicture: {
      preview: this.props.profilePicture,
    },
    mobile: this.props.mobile,
    dateOfBirth: this.props.dateOfBirth,
  }

  componentDidUpdate(prevProps) {
    if (!this.props.loading && prevProps.loading) {
      this.props.closeModal()
    }
  }

  submit = e => {
    e.preventDefault()
    this.props.updateUserInfo(this.props.consultantId, {
      name: this.state.name,
      employer: this.state.employer,
      titles: this.state.titles,
      availability: {
        ...this.state.availability,
        date:
          this.state.availability.date &&
            this.state.availability.type === 'date'
            ? this.state.availability.date.format('YYYY-MM-DD')
            : '',
        value:
          this.state.availability.type === 'other'
            ? this.state.availability.value
            : '',
      },
      profilePicture:
        this.state.profilePictureHasChanged && this.state.profilePicture,
      dateOfBirth: this.state.dateOfBirth,
      mobile: this.state.mobile,
    })
  }

  render() {
    return (
      <Form onSubmit={this.submit}>
        <Field>
          <Label htmlFor="profilePicture">Profilbilde</Label>
          <ProfilePictureInput
            id="profilePicture"
            value={this.state.profilePicture}
            onChange={profilePicture =>
              this.setState({
                profilePicture,
                profilePictureHasChanged: true,
              })
            }
          />
        </Field>
        <Field>
          <Label htmlFor="name">Navn</Label>
          <Input
            id="name"
            value={this.state.name}
            onChange={e => this.setState({ name: e.target.value })}
          />
        </Field>
        <Field>
          <Label htmlFor="dateOfBirth">
            Fødselsdato
          </Label>
          <Input
            type="text"
            id="dateOfBirth"
            placeholder="F.eks. 15.02.2003"
            value={this.state.dateOfBirth}
            onChange={e => this.setState({ dateOfBirth: e.target.value })}
          />
        </Field>
        <Field>
          <Label htmlFor="mobile">
            Mobilnummer
          </Label>
          <Input
            type="text"
            id="mobile"
            placeholder="F.eks. 00 00 00 00"
            value={this.state.mobile}
            onChange={e => this.setState({ mobile: e.target.value })}
          />
        </Field>
        {/*<Field>
          <Label htmlFor="employer">Arbeidsgiver</Label>
          <Input
            id="employer"
            value={this.state.employer}
            onChange={e => this.setState({ employer: e.target.value })}
          />
        </Field>*/}
        <Field>
          <Label htmlFor="titles">Hva har du lyst til å jobbe med?</Label>
          <RolesInput
            id="titles"
            value={this.state.titles}
            onChange={titles => this.setState({ titles })}
          />
        </Field>
        <Field>
          <Label htmlFor="availability">
            Når kan du jobbe?
          </Label>
          <AvailabilityInput
            id="availability"
            value={this.state.availability}
            onChange={availability => this.setState({ availability })}
          />
        </Field>
        <Button type="submit">Lagre</Button>
      </Form>
    )
  }
}

const mapStateToProps = (state, { consultantId }) => ({
  consultantId,
  loading: updateUserInfoPendingSelector(state),
  name: consultantNameSelector(state, consultantId),
  employer: consultantEmployerSelector(state, consultantId),
  titles: consultantTitlesSelector(state, consultantId) || [],
  availability: consultantAvailabilityValueSelector(state, consultantId) || {},
  profilePicture: consultantProfilePictureSelector(state, consultantId),
  mobile: consultantMobileSelector(state, consultantId),
  dateOfBirth: consultantDateOfBirthSelector(state, consultantId),
})

const mapDispatchToProps = { updateUserInfo }

export default connect(mapStateToProps, mapDispatchToProps)(EditUserInfo)



// WEBPACK FOOTER //
// ./src/components/EditUserInfo.js